
const BaseUrl = window.globalConfig.baseUrl
const pmBaseUrl = window.globalConfig.pmBaseUrl;
export default {
    GetMyDashboardSummary: BaseUrl + 'api/Dashboard/GetMyDashboardSummary',

    AddOfflineTime: BaseUrl + 'api/User/AddOfflineTime',

    GetMyDashboardDayWiseTrend: BaseUrl + 'api/Dashboard/GetMyDashboardDayWiseTrend',

    GetMyDashboardAttendanceTrend: BaseUrl + 'api/Dashboard/GetMyDashboardAttendanceTrend',

    GetMyDashboardCategoryList: BaseUrl + 'api/Dashboard/GetMyDashboardCategoryList',

    GetMyDashboardAppWebList: BaseUrl + 'api/Dashboard/GetMyDashboardAppWebList',

    GetMyDashboardCategoryWiseAppWeb: BaseUrl + 'api/Dashboard/GetMyDashboardCategoryWiseAppWeb',

    GetMyDashboardTenMinData: BaseUrl + 'api/Dashboard/GetMyDashboardTenMinData',

    GetMyDashboardHourlyData: BaseUrl + 'api/Dashboard/GetMyDashboardHourlyData',

    GetMyCalendarDetails: BaseUrl + 'api/Dashboard/GetMyCalender',

    GetProfileDetail: BaseUrl + 'api/user/GetProfileData',

    UpdateProfileDetail: BaseUrl + "api/user/UpdateProfileData",

    AddProfileDetails: BaseUrl + "api/user/AddUserLocal",


    AddUser: BaseUrl + "api/user/AddTeamRequest",

    DeleteUser: BaseUrl + "api/user/GetDeactiveUser",

    GetUserList: BaseUrl + "api/user/GetUserDropdown",

    GetAllUserList: BaseUrl + "api/user/GetUserDropdownAllUsers",

    GetUserDropdownAllUsersForOverTimeDropdown: BaseUrl + "api/user/GetUserDropdownWithFilters",

    GetFiltersForReport: BaseUrl + "api/Report/GetFiltersForReport",

    GetAllUser: BaseUrl + "api/user/GetUserListing",

    GetUnauthorizedUserList: BaseUrl + "api/User/GetUnauthorizedUserList",

    Login: BaseUrl + 'api/Account/Login',

    LoginAD: BaseUrl + 'api/Account/LoginAD',

    LoginSocialMedia: BaseUrl + 'api/Account/LoginSocialMedia',

    GetMyReportsReportDetail: BaseUrl + 'api/Report/GetReportDetails',

    GetMyReportsTableDetail: BaseUrl + 'api/Report/GetReportExportLog',
    //Executive summary
    GetDashboardQuickStats: BaseUrl + 'api/Dashboard/GetDashboardQuickStats',

    GetDatewiseDistribution: BaseUrl + 'api/Dashboard/GetDatewiseDistribution',

    GetDailyInAndOutTrend: BaseUrl + 'api/Dashboard/GetDailyInAndOutTrend',

    GetDateWiseActiveProductiveLogged: BaseUrl + 'api/Dashboard/GetDateWiseActiveProductiveLogged',

    GetBusinessUnitWiseProductivity: BaseUrl + 'api/Dashboard/GetBusinessUnitWiseProductivity',

    GetLocationWiseProductivity: BaseUrl + 'api/Dashboard/GetLocationWiseProductivity',

    GetDesignationWiseProductivity: BaseUrl + 'api/Dashboard/GetDesignationWiseProductivity',

    GetRoleWiseProductivity: BaseUrl + 'api/Dashboard/GetRoleWiseProductivity',

    GetTeamWiseProductivity: BaseUrl + 'api/Dashboard/GetTeamWiseProductivity',

    GetGroupWiseProductivity: BaseUrl + 'api/Dashboard/GetGroupWiseProductivity',

    GetTopAppWebsiteComparison: BaseUrl + 'api/Dashboard/GetTopAppWebsiteComparison',

    GetTopAppWebsiteTimeSplit: BaseUrl + 'api/Dashboard/GetTopAppWebsiteTimeSplit',

    //DeepDive
    GetAttendanceHeatMapMonthwise: BaseUrl + 'api/Dashboard/GetAttendanceHeatMapMonthwise',


    GetCountries: BaseUrl + 'api/Dashboard/GetCountryList',

    GetAttendanceHeatMapTeamwise: BaseUrl + 'api/Dashboard/GetAttendanceHeatMapTeamwise',

    GetHourlySpreadParent: BaseUrl + 'api/Dashboard/GetHourlySpreadParent',

    GetHourlySpreadChild: BaseUrl + 'api/Dashboard/GetHourlySpreadChild',

    GetTopProductive: BaseUrl + 'api/Dashboard/GetTopProductive',

    GetLeastProductive: BaseUrl + 'api/Dashboard/GetLeastProductive',

    GetDatewiseTimeGap: BaseUrl + 'api/Dashboard/GetDatewiseTimeGap',

    GetMyReportsSubmitDetail: BaseUrl + 'api/Report/AddReportRequest',

    GetTimezone: BaseUrl + 'api/Dashboard/GetTimeZoneList',

    GetAppWebCategory: BaseUrl + 'api/Dashboard/GetAppWebCategory',

    GetCategorywiseAppWeb: BaseUrl + 'api/Dashboard/GetCategorywiseAppWeb',

    DeActivateApplicationCategory: BaseUrl + 'api/Dashboard/DeActivateApplicationCategory',

    MapCategoryToApplication: BaseUrl + 'api/Dashboard/MapCategoryToApplication',

    UnMappedApplication: BaseUrl + 'api/Dashboard/UnMappedApplication',

    UpdateIdleTimeToApp: BaseUrl + 'api/Dashboard/UpdateIdleTimeToApp',

    UpdateAppProductiveUnProductive: BaseUrl + 'api/Dashboard/UpdateAppProductiveUnProductive',

    GetExceptionMappedApplication: BaseUrl + 'api/Dashboard/GetExceptionMappedApplication',

    GetOrganization: BaseUrl + 'api/Dashboard/GetOrganisationInfo',

    SubmitOrganization: BaseUrl + 'api/Dashboard/UpdateOrganisationInfo',

    GetMyReportsSearchApplicationDropdown: BaseUrl + 'api/Dashboard/GetAppWebForSearch',

    GetTimezone: BaseUrl + 'api/Dashboard/GetTimeZoneList',
    GetAgentConfiguration: BaseUrl + 'api/Dashboard/GetAgentConfiguration',

    SubmitAgentConfiguration: BaseUrl + 'api/Dashboard/updateAgentConfiguration',

    SubmitAgentConfiguration: BaseUrl + 'api/Dashboard/updateAgentConfiguration',

    GetAppWebForException: BaseUrl + 'api/Dashboard/GetAppWebForException',

    DeleteExceptionMappedApplication: BaseUrl + 'api/Dashboard/DeleteExceptionMappedApplication',

    AddExceptionMappedApplication: BaseUrl + 'api/Dashboard/AddExceptionMappedApplication',

    SubmitAgentConfiguration: BaseUrl + 'api/Dashboard/updateAgentConfiguration',

    SubmitScreenShotConfig: BaseUrl + 'api/Dashboard/AddScreenShotRequest',

    GetScreenShotRequest: BaseUrl + 'api/Dashboard/GetScreenShotsReq',

    GetScreenShotRequestList: BaseUrl + 'api/Dashboard/GetScreenShotsLists',

    GetScreenShotRequestSass: BaseUrl + 'api/Dashboard/GetScreenShotsReqSass',

    GetScreenShotRequestListSass: BaseUrl + 'api/Dashboard/GetScreenShotsListsSass',

    GetPendingTeamRequest: BaseUrl + "api/user/GetPendingTeamRequest",

    // PostRegister: BaseUrl + "api/user/EmailIdVerification",

    GetScreenShotRequest: BaseUrl + 'api/Dashboard/GetScreenShotsReq',

    GetPendingTeamRequest: BaseUrl + "api/user/GetPendingTeamRequest",

    //forgot password

    PostRegister: BaseUrl + "api/Account/Register",

    PostVerifyEmail: BaseUrl + "api/user/EmailIdVerification",

    updatePassword: BaseUrl + "api/Account/UpdatePassword",

    ForgotPasswordLog: BaseUrl + "api/Account/ForgotPasswordLog",

    SendOTP: BaseUrl + "api/Account/SendOTP",

    ResendOTP: BaseUrl + "api/Account/ResendOTP",

    VerifyOTP: BaseUrl + "api/Account/VerifyOTP",

    ChangePassword: BaseUrl + "api/Account/ChangePassword",

    //payment api
    GetSubcriptionDetails: BaseUrl + "api/Subcription/GetTrakzoSubcriptionDetails",

    GetPaymentInfo: BaseUrl + "api/Subcription/GetPaymentInfo",

    AddUpdatePaymentInfo: BaseUrl + "api/Subcription/AddUpdatePaymentMethodWithOrder",

    ConfirmOrderPayment: BaseUrl + "api/Subcription/ConfirmOrderPayment",

    AddUpdateTrakzoSubscription: BaseUrl + "api/Subcription/AddTrakZoSubcriptionRequest",

    AddUpdatePaymentMethod: BaseUrl + "api/Subcription/AddUpdatePaymentMethod",

    //System Resource

    GetHourlyApplicationWiseUserCount: BaseUrl + "api/Dashboard/GetHourlyApplicationWiseUserCount",

    GetHourlyApplicationWiseUserCountChild: BaseUrl + "api/Dashboard/GetHourlyApplicationWiseUserCountChild",

    GetRateCard: BaseUrl + "api/Subcription/GetRateCard",

    GetHourlyApplicationWiseUserCountChild: BaseUrl + "api/Dashboard/GetHourlyApplicationWiseUserCountChild",

    // GetRateCard: BaseUrl + "api/Subcription/GetRateCard",

    GetApplicationCategoryGroup: BaseUrl + "api/Dashboard/GetApplicationCategoryGroup",

    GetApplicationCategoryGroupChild: BaseUrl + "api/Dashboard/GetApplicationCategoryGroupChild",

    AddSubcriptionRequest: BaseUrl + "api/Subcription/AddSubcriptionRequest",

    GetWebsiteCategoryGroup: BaseUrl + "api/Dashboard/GetWebsiteCategoryGroup",

    GetWebsiteCategoryGroupChild: BaseUrl + "api/Dashboard/GetWebsiteCategoryGroupChild",

    GetApplicationCategoryData: BaseUrl + "api/Dashboard/GetApplicationCategoryData",

    GetApplicationCategorywiseAppData: BaseUrl + "api/Dashboard/GetApplicationCategorywiseAppData",

    GETWebsiteCategoryData: BaseUrl + "api/Dashboard/GETWebsiteCategoryData",

    GetWebsiteCategorywiseWebData: BaseUrl + "api/Dashboard/GetWebsiteCategorywiseWebData",

    downloadExe: BaseUrl + "api/Download/TrakZoWin",

    downloadZIPExe: BaseUrl + "api/Download/TrakZoWinZip",

    GetProfileImage: BaseUrl + "api/user/GetProfileImage",

    EmailExists: BaseUrl + "api/user/CheckIfEmailIdExists",

    UnSubscription: BaseUrl + "api/Subcription/UnSubscription",

    CancelTrakzoSubscription: BaseUrl + "api/Subcription/CancelTrakzoSubscription",

    PaymentStatus: BaseUrl + "api/Subcription/PaymentStatus",

    UpdatePaymentStatus: BaseUrl + "api/Subcription/UpdatePaymentStatus",

    GetuserDetailsForSubscription: BaseUrl + "api/Subcription/GetuserDetailsForSubscription"

    , PendingRequestMail: BaseUrl + "api/user/ResendTeamRequestMail",

    ResendUserInviteMail: BaseUrl + "api/user/ResendUserInviteMail",

    RemoveTeamRequest: BaseUrl + "api/user/RemoveTeamRequest",

    GetLicenseDetails: BaseUrl + "api/License/GetLicenseDetails",

    UploadLicense: BaseUrl + "api/License/UploadLicense",

    GetMyTeamFilter: BaseUrl + "api/Dashboard/GetMyTeamFilter",

    GetUninstallUnauthorizeAgent: BaseUrl + "api/User/GetUninstallUnauthorizeAgent",

    UpdateAndAuthorizeAgent: BaseUrl + "api/User/UpdateAndAuthorizeAgent",

    GetapplicationList: BaseUrl + "api/RestrictedApp/GetapplicationList",

    GetRestirictedApp: BaseUrl + "api/RestrictedApp/GetRestirictedApp",

    AddUpdateRestirictedApp: BaseUrl + "api/RestrictedApp/AddUpdateRestirictedApp",

    DeleteRestrictedApps: BaseUrl + "api/RestrictedApp/DeleteRestrictedApps",

    GetLicenseDetailsForList: BaseUrl + "api/License/GetLicenseDetailsForList"

    , GetOfflineTime: BaseUrl + "api/RestrictedApp/GetOfflineTime"

    , ApproveRejectOfflineRequest: BaseUrl + "api/RestrictedApp/ApproveDeclineOfflineTimeRequest"

    , AddUpdateSMTP: BaseUrl + "api/SMTP/AddUpdateSMTP"

    , GetSMTPConfigurationForSMTPPage: BaseUrl + "api/SMTP/GetSMTPConfigurationForSMTPPage"

    , TestSMTP: BaseUrl + "api/SMTP/TestSMTP"
    , GetOfflineTime: BaseUrl + "api/RestrictedApp/GetOfflineTime"

    , ApproveRejectOfflineRequest: BaseUrl + "api/RestrictedApp/ApproveDeclineOfflineTimeRequest"
    , GetOfflineTimeLog: BaseUrl + "api/RestrictedApp/GetOfflineTimeRequestLog"
    , UserUpload: BaseUrl + "api/User/UserUpload"
    , downloadSample: BaseUrl + "api/User/ExcelFormatDownload"
    , GetBulkUploadLog: BaseUrl + "api/User/GetBulkUploadLog",
    GetApplicationMasterList: BaseUrl + "api/Application/GetApplicationMasterList",
    AddSkipApplication: BaseUrl + "api/Application/AddSkipApplication",
    UpdateDisplayName: BaseUrl + "api/Application/UpdateDisplayName",
    AddCategory: BaseUrl + "api/Application/AddCategory",
    BulkUploadStatusFileDownload: BaseUrl + "api/User/BulkUploadStatusFileDownload",
    GetUserRights: BaseUrl + "api/User/GetUserRights",
    GetTimeSheetData: BaseUrl + "api/Dashboard/GetTimeSheetData",
    // GetWorkingHoursLists: BaseUrl + "api/WorkingHours/GetWorkingHoursListsWithOvertime",
    // InsertUpdateWorkingHours: BaseUrl + "api/WorkingHours/InsertUpdateWorkingHoursWithOvertime",
    GetWorkingHoursLists: BaseUrl + "api/WorkingHours/GetWorkingHoursLists",
    InsertUpdateWorkingHours: BaseUrl + "api/WorkingHours/InsertUpdateWorkingHours",
    GetLeaveData: BaseUrl + "api/LeaveData/GetLeaveData",
    LeaveDataFormatDownload: BaseUrl + "api/LeaveData/LeaveDataFormatDownload",
    UploadLeaveData: BaseUrl + "api/LeaveData/UploadLeaveData",

    GetDashboardConfigurationList: BaseUrl + 'api/Dashboard/GetDashboardConfigurationList',

    GetReportManagerList: BaseUrl + 'api/Dashboard/GetReportManagerList',

    SaveConfiguration: BaseUrl + 'api/Dashboard/SaveConfiguration',

    DeleteDelegate: BaseUrl + 'api/Dashboard/DeleteDelegate',

    GetUserCount: BaseUrl + 'api/Dashboard/GetUserCount',

    GetHourlySpreadChildrenReport: BaseUrl + 'api/Dashboard/GetHourlySpreadChildrenReport',
    AbsenceReport: BaseUrl + 'api/Dashboard/GetAbsenceData',

    TrakzoLite: BaseUrl + 'api/Dashboard/GetUserCheckinCheckoutLite',

    GetAssetDetails: BaseUrl + 'api/Dashboard/GetAssetDetails',

    GetWorkingHourConfigForProfile: BaseUrl + 'api/User/GetWorkingHourConfig',
    GetDropdownForMailSchedule: BaseUrl + 'api/Dashboard/GetDropdownDetailsForMailSchedule',

    SubmitMailSchedule: BaseUrl + 'api/Dashboard/AddMailSchedule',
    GetMailScheduledetails: BaseUrl + 'api/Dashboard/GetMailScheduleDetails',
    DeleteMailSchedule: BaseUrl + 'api/Dashboard/DeleteMailSchedule',
    SubmitGenericHoliday: BaseUrl + 'api/GenericHoliday/AddUpdateGenericHoliday',
    GetGenericHoliday: BaseUrl + 'api/GenericHoliday/GetGenericHolidayDetails',
    DeleteGenericHoliday: BaseUrl + 'api/GenericHoliday/DeleteGenericHoliday',
    FromatGenericHoliday: BaseUrl + 'api/GenericHoliday/HolidayExcelFormatDownload',
    UploadHoliday: BaseUrl + 'api/GenericHoliday/GenericHolidayUpload',
    UploadHolidayStatusLog: BaseUrl + 'api/GenericHoliday/GetBulkUploadLog',
    UploadHolidayStatusFileDownload: BaseUrl + 'api/GenericHoliday/BulkUploadStatusFileDownload',

    RemoveUserDevice: BaseUrl + 'api/User/RemoveUserDevice',


    GetAttendanceData: BaseUrl + "api/Attendance/GetAttendanceData",

    
   
    GetFilterDetails: BaseUrl + 'api/Dashboard/GetFilterDetails',

    GetSWAssetDetails: BaseUrl + 'api/Dashboard/GetSWAssetDetails',

    GetUnMappedApplicationList: BaseUrl + 'api/Dashboard/GetUnMappedApplicationList',

    GetSkippedApplicationList: BaseUrl + 'api/Dashboard/GetSkipApplication',

    RemoveSkipApplication: BaseUrl + 'api/Dashboard/RemoveSkipApplication',

    MapApplications: BaseUrl + 'api/Dashboard/MapApplications',

    GetHardwareDashboarddetails: BaseUrl + 'Api/ItemReport/GetHardwareDashboarddetails ',
    // AddUpdateEmpDetails: 'https://localhost:44374/' + 'api/CapacityModule/UpdateEmployeeOfficialInfo',

    GetHardWareSummary: BaseUrl + 'Api/ItemReport/GetHardWareSummary',

    GetLicenseStatistics: BaseUrl + 'api/itemreport/GetLicenseStatistics',

    GetUserListByBios: BaseUrl + 'Api/itemreport/GetUserListByBios',

    GetUserWiseDashboardITAM: BaseUrl + 'Api/ItemReport/GetUserWiseDashboardITAM',
    GetSystemUsernameList: BaseUrl + 'Api/ItemReport/GetSystemUsernameList',
    LicenseStatisticsUploadFormat:BaseUrl+'Api/ItemReport/LicenseStatisticsFormatDownload',
    LicenseStatisticsUpload:BaseUrl+'Api/ItemReport/LicenseStatisticUpload',

    HardwareReportCsvDownload:BaseUrl+'Api/AssetReport/HardwareReport',
    GetSoftwareByComputerReportCsvDownload:BaseUrl+'Api/AssetReport/GetSoftwareByComputerReport',
    GetLicenseStatisticsReportCsvDownload:BaseUrl+'Api/AssetReport/GetLicenseStatisticsReport',
    OSOverViewReportCsvDownload:BaseUrl+'Api/AssetReport/OSOverViewReport',
    GetLaptopDesktopReportCsvDownload:BaseUrl+'Api/AssetReport/GetLaptopDesktopReport',

    GetOSPublisherCountDetails: BaseUrl + 'Api/ItemReport/GetOSPublisherCountDetails',
    GetOsPublisherDetailWithSystemName:BaseUrl + 'Api/ItemReport/GetOsPublisherDetailWithSystemName',
    GetHolidayDetailsForMyDashboard:BaseUrl + 'api/Dashboard/GetHolidayDetailsForMyDashboard',
   
    // CapacityPlanningUpdateTask: 'https://localhost:44374/' + 'api/CapacityModule/CapacityPlanningUpdat

    //PM
      GetTeamMemberWiseProjects: pmBaseUrl + "api/ProjectModule/GetTeamMemberWiseProjects",

    AddUpdateMilestone: pmBaseUrl + "api/ProjectModule/AddUpdateTask",

    AddUpdateSkillsetItems: pmBaseUrl + 'api/CapacityModule/AddUpdateSkillsetItems',

    AddUpdateSkillsets: pmBaseUrl + 'api/CapacityModule/AddUpdateSkillsets',

    GetEmployeesUtilization: pmBaseUrl + "api/CapacityModule/GetEmployeesUtilization",

    AddUpdateEmpDetails: pmBaseUrl + 'api/CapacityModule/UpdateEmployeeOfficialInfo',

    loadSkillsetAndSkillItemsList: pmBaseUrl + 'api/CapacityModule/GetSkillsetDetails',

    employeeBulkUpload: pmBaseUrl + 'api/CapacityModule/EmployeeDetailsUpload',

    getCapacityPlanDashBoardData: pmBaseUrl + 'api/CapacityModule/CapacityPlaningDashboard',

    getCapacityPlanningDashboardCard: pmBaseUrl + 'api/CapacityModule/CapacityPlanningDashboardCard',

    getCapacityPlanDashBoardDataEmpAndProj: pmBaseUrl + 'api/CapacityModule/CPDashboardEmpoyeeAndProjectWise',

    getCapacityPlanDashBoardProjectUtilization: pmBaseUrl + 'api/CapacityModule/CPDashboardProjectUtilization',

    CapacityPlanningUpdateTask: pmBaseUrl + 'api/CapacityModule/CapacityPlanningUpdateTask',

    AddUpdateProjects: pmBaseUrl + "api/ProjectModule/AddUpdateProjects",
     downloadLinuxExe: BaseUrl + "api/Download/TrakZoLinux",

    downloadLinuxZIPExe: BaseUrl + "api/Download/TrakZoLinuxZip",

    GetMonthwiseDistribution: BaseUrl + 'api/Dashboard/GetMonthwiseDistribution',
    GetWeekwiseDistribution: BaseUrl + 'api/Dashboard/GetWeekwiseDistribution',
    downloadUserSampleFormat:BaseUrl+'api/User/AssetReporUserExcelFormat',
     UploadUserStatusFileDownload: BaseUrl + 'api/User/AssetReportUserBulkUploadStatusFileDownload',
      GetAssetReportUserBulkUploadLog: BaseUrl + "api/User/GetAssetReportUserBulkUploadLog",
      AssetReportUserUpload: BaseUrl + "api/User/AssetReportUserUpload",
      downloadInactiveUserSampleFormat:BaseUrl+'api/User/InActiveUserExcelFormat',
      InActivateUserUpload: BaseUrl + "api/User/InActivateUserUpload",
      GetInactivateUserBulkUploadLog: BaseUrl + "api/User/GetInactivateUserBulkUploadLog",
      
      InactiveUserUploadStatusDownload: BaseUrl + "api/User/InactiveUserUploadStatusDownload",
      downloadMacZIPExe: BaseUrl + "api/Download/TrakZoMacZip",
    GetLatestTransactions: BaseUrl + "api/Subcription/GetLatestTransactions"

};